import { render, staticRenderFns } from "./vip-alert.vue?vue&type=template&id=20b302ea&scoped=true"
import script from "./vip-alert.vue?vue&type=script&lang=js"
export * from "./vip-alert.vue?vue&type=script&lang=js"
import style0 from "./vip-alert.vue?vue&type=style&index=0&id=20b302ea&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b302ea",
  null
  
)

export default component.exports